export class signupFormInfo {
    constructor(companyId, userName, companyPassword, emailAddress, password, authenticationCode, userClass = '1') {
        this.userClass = userClass;
        this.userName = userName;
        this.companyId = companyId;
        this.companyPassword = companyPassword;
        this.emailAddress = emailAddress;
        this.password = password;
        this.authenticationCode = authenticationCode;
    }
}
